import {
  post as commonPost,
  get as commonGet,
  put as commonPut,
  deletes as commonDelete,
} from '@/utils/http';

export function post(url, param = '', prefixUrl = process.env.VUE_APP_CRCS_API, showLoading = true) {
  return commonPost(url, param, prefixUrl, showLoading);
}

export function get(url, param = '', prefixUrl = process.env.VUE_APP_CRCS_API, showLoading = true) {
  return commonGet(url, param, prefixUrl, showLoading);
}

export function put(url, param = '', prefixUrl = process.env.VUE_APP_CRCS_API, showLoading = true) {
  return commonPut(url, param, prefixUrl, showLoading);
}

export function remove(url, param = '', prefixUrl = process.env.VUE_APP_CRCS_API, showLoading = true) {
  return commonDelete(url, param, prefixUrl, showLoading);
}
